export { wplToken } from './get-token';
